/**
 * Canale minimale fra l'interceptor axios e la UI per le negazioni di autorizzazione.
 *
 * Esiste come modulo separato per non far dipendere un componente React dall'intero
 * client axios (e con esso da keycloak e dalla configurazione d'ambiente) solo per
 * sottoscriversi a un evento.
 */

const listeners = new Set();

/**
 * Sottoscrive un listener alle negazioni 403.
 * @param {(detail: {method: string, url: string}) => void} listener
 * @returns {() => void} funzione di disiscrizione
 */
export const onForbidden = (listener) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Notifica tutti i listener di una negazione 403.
 *
 * Ogni listener è isolato: l'emissione avviene in modo sincrono dentro
 * l'interceptor axios, quindi un listener che solleva impedirebbe la reject
 * dell'errore originale (il codice chiamante riceverebbe l'errore del listener
 * al posto di quello axios) e bloccherebbe i listener successivi.
 *
 * @param {{method: string, url: string}} detail
 */
export const emitForbidden = (detail) => {
  listeners.forEach((listener) => {
    try {
      listener(detail);
    } catch (listenerError) {
      // Un listener difettoso non deve alterare il flusso di errore della richiesta.
      console.error('Listener onForbidden fallito', listenerError);
    }
  });
};
